import { render } from "./CommonSkeletonLoader.vue?vue&type=template&id=8a250d76&scoped=true"
import script from "./CommonSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CommonSkeletonLoader.vue?vue&type=script&lang=js"

import "./CommonSkeletonLoader.vue?vue&type=style&index=0&id=8a250d76&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a250d76"]])

export default __exports__